export default "__VITE_ASSET__DFrdJTGV__"